/* Returns a Promise to be manually resolved or rejected.
Usage:
  const deferred = makeDeferred();
  ...
  deferred.resolve();
*/

export type Deferred<T> = Promise<T> & {resolve(result?: T): void; reject(reason?: unknown): void};

export default function makeDeferred<T>(): Deferred<T> {
  let res;
  let rej;

  const promise: Partial<Deferred<T>> = new Promise((resolve, reject) => {
    res = resolve;
    rej = reject;
  });

  promise.resolve = res;
  promise.reject = rej;

  return promise as Deferred<T>;
}
